import React, {useState, useEffect, Fragment} from 'react'
import { Link } from 'react-router-dom';
import flatstore from 'flatstore';
import {getBasketCount} from '../../../utils/services';
import {currentLang} from '../../../utils/functions';
import W from '../Word';

const Basket = ({basket_count}) => {
    const [count, setCount] = useState(0)
    useEffect(() => {
        if(basket_count == undefined){
            getBasketCount();
        }else{
            if(!count && basket_count.count){
                setCount(basket_count.count);
            }
        }
    }, [basket_count])

    return (
        <Fragment>
            <a href={"/"+currentLang()+"/shop/"}>
              <i className="icon-basket"></i>
              {count > 0 &&
                <span className="basket-count">{count}</span>
              }
                <W>general.checkout</W>
            </a>
        </Fragment>
    )
}

export default flatstore.connect(['basket_count'])(Basket);
